<template>
  <div class="_promobookingform">
    <div class="_promobookingform__wrapper">
      <PromoBookingHeader class="_promobookingform__wrapper--header"></PromoBookingHeader>
      <div class="_promobookingform__wrapper--content">

        <div class="__shipmentDate ">
            <div v-b-toggle.collapse-1 @click="show1 = !show1">
                <div class="cardheader d-flex justify-content-end align-items-center __pointer">
                  <transition name="fade">
                    <b v-if="show1">Shipment Date & Details</b>
                  </transition>
                  <img  class="__arrow" src="@/assets/image/gray-up-arrow@3x.svg" alt="">
                </div>
            </div>
            <b-collapse id="collapse-1" >
              <div class="d-flex flex-column __shimpentsection">
                  <p class="__title"><b>Shipment Date</b></p>
                  <input class="__inputDate text-center" type="text" placeholder="DD/MM/YY">
              </div>
              <div>
                  <p class="__title"><b>Shipment Details</b></p>
                  <div class="d-flex flex-row">
                    <div class="d-flex flex-column mr-5">
                      <p class="__subtitle">Qty</p>
                      <div class="__customdropdown_dst">
                        <b-input-group>
                          <b-form-input class="__qty" type="number" placeholder="0" />
                          <b-dropdown right>
                             <template slot="button-content">
                              <p>{{optionValue.Qty}}</p>
                            </template>
                            <b-dropdown-item @click="selectedOption(option.text,'Qty')" v-for="option in optionQty" :key="option.id">
                              <span>{{option.text}}</span>
                            </b-dropdown-item>
                          </b-dropdown>
                          <img class="__imgArrow" src = "../../assets/image/instantprice/right-arrow.svg">
                        </b-input-group>
                      </div>
                    </div>

                    <div class="row __weight mb-5 mr-5" v-if="!FCL">
                      <p class="__subtitle">Weight</p>
                      <b-input-group size="md" append="kg">
                        <b-form-input type="number" placeholder="0" />
                      </b-input-group>
                      <p class="__minimum">*minimum 50kg</p>
                    </div>
                    <div class="row __size mb-5 mr-5" v-if="!FCL">
                      <p class="__subtitle">Size</p>
                      <b-input-group size="md" append="cm">
                        <b-form-input type="number" placeholder="L" />
                        <b-form-input type="number" placeholder="W" />
                        <b-form-input type="number" placeholder="H" />
                      </b-input-group>
                    </div>
                    <div class="d-flex flex-column __container mb-5 mr-5" v-if="FCL">
                      <p class="__subtitle">Container Type</p>
                      <p class="__reefer d-flex justify-content-center align-items-center">Reefer</p>
                    </div>
                    <div class=" __temperature mb-5 mr-5" v-if="FCL">
                      <p class="__subtitle">Temperature</p>
                      <div class="d-flex __tempcontent flex-row">
                         <span class="__max d-flex justify-content-center align-items-center">Max.</span><span class="__celcius d-flex justify-content-center align-items-center">5'C</span>
                      </div>
                    </div>
                    <div class=" __sizereefer mb-5 mr-5" v-if="FCL">
                      <p class="__subtitle">Size</p>
                      <span class="__ft d-flex justify-content-center align-items-center">40 ft</span>
                    </div>
                  </div>
              </div>
            </b-collapse>
        </div>

        <div class="__productType ">
            <div v-b-toggle.collapse-2>
                <div class="cardheader d-flex justify-content-between align-items-center __pointer">
                  <b>Product Type</b>
                  <img  class="__arrow" src="@/assets/image/gray-up-arrow@3x.svg" alt="">
                </div>
            </div>
            <b-collapse id="collapse-2">
              <div class="d-flex flex-row">
                <div class="d-flex flex-column mr-4 mb-5">
                  <div class="__customdropdown_dst2">
                    <p class="__subtitle">Product Type</p>
                    <b-input-group>
                      <b-dropdown right>
                        <template slot="button-content">
                          <p>{{optionValue.Product}}</p>
                        </template>
                        <b-dropdown-item @click="selectedOption(option.text,'Product')" v-for="option in optionProductType" :key="option.id">
                          <span>{{option.text}}</span>
                        </b-dropdown-item>
                      </b-dropdown>
                      <img class="__imgArrow" src = "../../assets/image/instantprice/right-arrow.svg">
                    </b-input-group>
                  </div>
                  <div class="__customdropdown_dst2">
                    <p class="__subtitle mt-3">What kind of goods you shipped?</p>
                    <b-input-group>
                      <b-dropdown right>
                        <template slot="button-content">
                          <p>{{optionValue.Goods}}</p>
                        </template>
                        <b-dropdown-item @click="selectedOption(option.text,'Goods')" v-for="option in optionGoodsType" :key="option.id">
                          <span>{{option.text}}</span>
                        </b-dropdown-item>
                      </b-dropdown>
                      <img class="__imgArrow" src = "../../assets/image/instantprice/right-arrow.svg">
                    </b-input-group>
                  </div>
                  <p class="__subtitle mt-3">Product Description</p>
                  <div class="__customdropdown_dst">
                    <div>
                      <b-form-textarea
                        id="textarea"

                        placeholder="Type Your Product Description"
                        rows="3"
                        max-rows="5"
                        class="__textarea"
                      />
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div class="__goods">
                    <p class="__subtitle">Value of goods (IDR)</p>
                    <b-input-group class="__input">
                      <b-form-input type="number" placeholder="0" />
                    </b-input-group>
                  </div>
                  <div class="d-flex flex-column __code">
                    <p class="__subtitle mt-3">HS Code</p>
                    <b-input-group class="__input">
                      <b-form-input type="number" placeholder="0" />
                    </b-input-group>
                  </div>
                </div>
              </div>
            </b-collapse>
        </div>

        <div class="__addOption">
            <div v-b-toggle.collapse-3>
                <div class="cardheader d-flex justify-content-between align-items-center __pointer">
                  <b >Additional Options</b>
                  <img  class="__arrow" src="@/assets/image/gray-up-arrow@3x.svg" alt="">
                </div>
            </div>
            <b-collapse id="collapse-3">
                <div class="d-flex flex-column __block3">
                  <p class="__subtitle">Additional options</p>
                  <div class="__addoption d-flex flex-row align-items-center">
                    <img class="__icon" src = "../../assets/image/icon/shield.svg">
                    <span class="__text1">Insurance</span>
                    <div class="custom-control custom-switch __switchCustom">
                      <input type="checkbox" class="custom-control-input" id="customSwitch1">
                      <label class="custom-control-label __pointer" for="customSwitch1"></label>
                    </div>
                  </div>
                  <div class="__addoption d-flex flex-row align-items-center">
                    <img class="__icon" src = "../../assets/image/icon/customs.svg">
                    <span class="__text">Customs Clearance (Origin)</span>
                    <div class="custom-control custom-switch __switchCustom">
                      <input type="checkbox" class="custom-control-input" id="customSwitch2">
                      <label class="custom-control-label __pointer" for="customSwitch2"></label>
                    </div>
                  </div>
                  <div class="__addoption d-flex flex-row mb-5 align-items-center">
                    <img class="__icon" src = "../../assets/image/icon/customs.svg">
                    <span class="__text">Customs Clearance (Destination)</span>
                    <div class="custom-control custom-switch __switchCustom">
                      <input type="checkbox" class="custom-control-input" id="customSwitch3">
                      <label class="custom-control-label __pointer" for="customSwitch3"></label>
                    </div>
                  </div>
                </div>
            </b-collapse>
        </div>

        <div class="__pickupDeliv">
            <div v-b-toggle.collapse-4>
                <div class="cardheader d-flex justify-content-between align-items-center __pointer">
                  <b>Pick Up & Delivery Address</b>
                  <img  class="__arrow pull-right" src="@/assets/image/gray-up-arrow@3x.svg" alt="">
                </div>
            </div>
            <b-collapse id="collapse-4">
              <p class="__subtitle mt-3">Pick Up Address</p>
              <b-form-textarea
                id="textarea"
                placeholder=""
                rows="3"
                max-rows="5"
                class="__textarea"
                  />
              <p class="__subtitle mt-3">Delivery Address</p>
              <b-form-textarea
                id="textarea"
                placeholder=""
                rows="3"
                max-rows="5"
                class="__textarea mb-5"
                  />
                <pre class="mt-3 mb-0"></pre>
            </b-collapse>
        </div>

        <div class="__shipperconsigne">
            <div v-b-toggle.collapse-5 @click="show2 = !show2">
                <div class="cardheader d-flex justify-content-end align-items-center __pointer">
                  <transition name="fade">
                    <b v-if="show2">Shipper & Consignee Details</b>
                  </transition>
                  <img  class="__arrow" src="@/assets/image/gray-up-arrow@3x.svg" alt="">
                </div>
            </div>
            <b-collapse id="collapse-5">
              <p class="__title"><b>Shipper Details</b></p>
              <div class="d-flex flex-row justify-content-center">
                <div class="d-flex flex-column mr-4">
                    <div class="__shipName">
                      <p class="__subtitle">Shipper PIC Name</p>
                      <b-input-group class="__input">
                        <b-form-input type="text" placeholder="Insert Shipper PIC Full Name" />
                      </b-input-group>
                    </div>
                    <div class="__shipPhone mt-3">
                      <p class="__subtitle">Phone</p>
                      <b-input-group class="__input">
                        <b-form-input type="number" placeholder="Shipper PIC Phone Number" />
                      </b-input-group>
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <div class="__shipCompanyName">
                      <p class="__subtitle">Company Name</p>
                      <b-input-group class="__input2">
                        <b-form-input type="text" placeholder="Shipper Company Name" />
                      </b-input-group>
                    </div>
                    <div class="__shipCompanyAddress mt-3">
                      <p class="__subtitle">Company Address</p>
                      <div class="__customdropdown_dst">
                        <div>
                          <b-form-textarea
                            id="textarea"
                            placeholder="Shipper Company Address"
                            rows="3"
                            max-rows="5"
                            class="__textarea"
                              />
                            <pre class="mt-3 mb-5"></pre>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              <p class="__title"><b>Consignee Details</b></p>
              <div class="d-flex flex-row justify-content-center">
                <div class="d-flex flex-column mr-4">
                    <div class="__consName">
                      <p class="__subtitle">Consignee PIC Name </p>
                      <b-input-group class="__input">
                        <b-form-input type="text" placeholder="Insert Consignee PIC Full Name" />
                      </b-input-group>
                    </div>
                    <div class="__consPhone mt-3">
                      <p class="__subtitle">Phone</p>
                      <b-input-group class="__input">
                        <b-form-input type="number" placeholder="Consignee PIC Phone Number" />
                      </b-input-group>
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <div class="__consCompanyName">
                      <p class="__subtitle">Company Name</p>
                      <b-input-group class="__input2">
                        <b-form-input type="text" placeholder="Consignee Company Name" />
                      </b-input-group>
                    </div>
                    <div class="__consCompanyAddress mt-3">
                      <p class="__subtitle">Company Address</p>
                      <div class="__customdropdown_dst">
                        <div>
                          <b-form-textarea
                            id="textarea"
                            placeholder="Consignee Company Address"
                            rows="3"
                            max-rows="5"
                            class="__textarea"
                              />
                            <pre class="mt-3 mb-0"></pre>
                        </div>
                      </div>
                    </div>
                </div>
              </div>

              <div class="__notes d-flex justify-content-center">
                <div>
                      <p class="__notesTitle mt-3">Notes</p>
                      <div class="__customdropdown_dst">
                          <b-form-textarea
                            id="textarea"
                            placeholder="Type Here"
                            rows="3"
                            max-rows="5"
                            class="__textareaNotes"
                            />
                      </div>
                    <p class="__optional mb-5">*Optional</p>
                  </div>
                </div>
            </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import PromoBookingHeader from '@/components/promo/PromoBookingHeader'
export default {
  name: 'ipbookingform',
  components: {
    PromoBookingHeader
  },
  data () {
    return {
      form: {
        SDname: '',
        SDphone: '',
        SDcompany: '',
        SDadrs: '',
        CDname: '',
        CDphone: '',
        CDcompany: '',
        CDadrs: '',
        notes: ''
      },
      optionValue: {
        Qty: 'Boxes',
        Product: 'General Cargo',
        Goods: 'Live Animal (AVI)'
      },
      optionQty:
      [
        { id: 1, text: 'Boxes', value: '' },
        { id: 2, text: 'Creates', value: '' },
        { id: 3, text: 'Palletes', value: '' }
      ],
      optionProductType:
      [
        { id: 1, text: 'General Cargo', value: '' },
        { id: 2, text: 'Special Cargo', value: '' },
        { id: 3, text: 'Dangerous Goods', value: '' }
      ],
      optionGoodsType:
      [
        { id: 1, text: 'Live Animal (AVI)', value: '' },
        { id: 2, text: 'Human Remain (HUM)', value: '' },
        { id: 3, text: 'Perishable Goods', value: '' }
      ],
      show1: true,
      show2: true,
      FCL: true
    }
  },
  methods: {
    placeOrder: function () {
      this.$eventHub.$emit('dialog-instantprice-form')
    },
    priceDetails: function () {
      this.$eventHub.$emit('dialog-pricedetails')
    },
    selectedOption: function (event, type) {
      if (type === 'Qty') {
        this.optionValue.Qty = event
      } else if (type === 'Product') {
        this.optionValue.Product = event
      } else if (type === 'Goods') {
        this.optionValue.Goods = event
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/PromobookingForm/index.vue